export enum TabIdList {
  DataCollection = 'data-collection',
  InformationUsage = 'information-usage',
  InformationDisclosure = 'information-disclosure',
  InformationSharing = 'information-sharing',
  Rights = 'rights',
  InformationStoring = 'information-storing',
  SecurityAndAge = 'security-and-age',
  ContactUs = 'contact-us',
  UsResidents = 'us-residents',
}

export enum TabColorList {
  DataCollection = '#FFF4BC',
  InformationUsage = '#FFEA7E',
  InformationDisclosure = '#FFDE3B',
  InformationSharing = '#FFD232',
  Rights = '#FFC629',
  InformationStoring = '#FFBD15',
  SecurityAndAge = '#F6B112',
  ContactUs = '#FFF500',
  UsResidents = '#FBCA00',
}
